export const optionButtonMobileContainer = {
  minWidth: "260px",
  maxWidth: "330px",
  overflowX: "scroll",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  "> button:first-of-type": {
    flexGrow: 1,
    flexShrink: 1,
    mr: "20px",
  },
};

export const hint = {
  maxWidth: "220px",
  color: "grey5",
  fontFamily: "roboto",
  fontWeight: "light",
  fontSize: "16px",
  lineHeight: "1.25",
  letterSpacing: "0.05em",
};
